import { getActiveSignUpPagePromoBanner } from '#utils/signUpPage';

/*
  Steps for adding new banner:
    1. Add new variation to sign-up-page-promo-banner in LaunchDarkly
    2. Update the signUpPagePromoBanner union in packages/dogfood-flags/src/dogfood-flags.ts
    3. Add enum value to SignUpPagePromoBanners in static/ld/utils/signUpPage.ts
    4. Create new banner in static/ld/components/signUp/banners/
    5. Add a new case below for your banner
      ex: case SignUpPagePromoBanners.{variation}: <NewBanner />
    6. Turn on flag
*/

export function FlagControlledSignUpBannerContainer() {
  const activeBanner = getActiveSignUpPagePromoBanner();

  if (!activeBanner) {
    return null;
  }

  switch (activeBanner) {
    default:
      return null;
  }
}
